import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = "GBP") {
  if (amount === null || amount === undefined) return "—";
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatNumber(num) {
  if (num === null || num === undefined) return "—";
  return new Intl.NumberFormat("en-GB").format(num);
}

export function formatRank(rank) {
  if (rank === null || rank === undefined) return "—";
  if (rank >= 1000000) {
    return `${(rank / 1000000).toFixed(1)}M`;
  }
  if (rank >= 1000) {
    return `${(rank / 1000).toFixed(0)}K`;
  }
  return rank.toString();
}

export function getStatusConfig(status) {
  const configs = {
    SOURCED: { label: "Sourced", className: "status-sourced", color: "blue" },
    INBOUND_TO_PREP: { label: "Inbound", className: "status-inbound", color: "orange" },
    PREPPED: { label: "Prepped", className: "status-prepped", color: "purple" },
    SHIPPED_TO_FBA: { label: "Shipped", className: "status-shipped", color: "cyan" },
    LIVE: { label: "Live", className: "status-live", color: "emerald" },
    SOLD: { label: "Sold", className: "status-sold", color: "yellow" },
    AVAILABLE: { label: "Available", className: "bg-secondary text-secondary-foreground", color: "gray" },
  };
  return configs[status] || configs.AVAILABLE;
}

export function getCountryFlag(countryCode) {
  const flags = {
    GB: "🇬🇧",
    US: "🇺🇸",
    DE: "🇩🇪",
    FR: "🇫🇷",
    IT: "🇮🇹",
    ES: "🇪🇸",
    CA: "🇨🇦",
    AU: "🇦🇺",
    JP: "🇯🇵",
    CN: "🇨🇳",
  };
  return flags[countryCode] || "🌍";
}

export function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
